import { useState, useEffect } from "react";
import { colors, font, maxWidth, heroImage } from "../styles/theme";
import { contacts } from "../data/company";
import { useRequestModal } from "../components/ModalProvider";
import HeroBrand from "../components/HeroBrand";
import CalcForm from "../components/CalcForm";
import ServicesStrip from "../components/ServicesStrip";
import ObjectTypesBar from "../components/ObjectTypesBar";

// Intro играет один раз за загрузку страницы. Модульный флаг переживает
// перемонтирование компонента (StrictMode в dev, повторный заход на главную).
let introPlayed = false;

// Вариант 2 — как вариант 1, но hero-блок на фоновом фото montazh-electriki.jpg.
export default function Hero2({ scrolled }) {
  const { openRequest } = useRequestModal();

  // phase: "loading" — ждём ассеты (всё скрыто), "playing" — играет intro,
  // "done" — анимация доиграла (класс снят). Если intro уже играла — сразу "done".
  const [phase, setPhase] = useState(introPlayed ? "done" : "loading");

  // Предзагрузка логотипа и hero-фото: анимацию запускаем только когда они готовы.
  useEffect(() => {
    if (introPlayed) return; // уже играла в этой загрузке страницы
    let started = false;
    const start = () => {
      if (started || introPlayed) return;
      started = true;
      introPlayed = true;
      clearTimeout(fb);
      setPhase("playing");
    };
    const load = (src) =>
      new Promise((res) => {
        const img = new Image();
        img.onload = img.onerror = res;
        img.src = src;
      });

    Promise.all([load("/logo-klimat.png"), load(heroImage)]).then(start);
    // Фолбэк: не ждём дольше 4с, даже если что-то не догрузилось.
    const fb = setTimeout(start, 4000);
    return () => clearTimeout(fb);
    // eslint-disable-next-line
  }, []);

  // После старта intro — снимаем класс, когда все анимации доиграли (~3с).
  useEffect(() => {
    if (phase !== "playing") return;
    const t = setTimeout(() => setPhase("done"), 3000);
    return () => clearTimeout(t);
  }, [phase]);

  const heroClass = phase === "loading" ? "hero-preload" : phase === "playing" ? "hero-intro" : undefined;

  return (
    <section className={heroClass} style={{ background: colors.bgLight }}>
      <div className="hero-outer" style={{ maxWidth, margin: "0 auto", padding: "38px 22px 40px" }}>
        <div className="hi-brand">
          <HeroBrand hidden={scrolled} />
        </div>

        <div
          className="hero-banner hi-banner"
          style={{
            position: "relative",
            borderRadius: 22,
            overflow: "hidden",
            marginTop: 36,
            boxShadow: "0 26px 60px rgba(18,24,38,.16)",
          }}
        >
          <div
            className="hi-photo"
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url('${heroImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(102deg,rgba(10,10,14,.92) 0%,rgba(10,10,14,.78) 48%,rgba(12,12,16,.40) 100%)",
            }}
          />
          <div className="hero-banner-pad" style={{ position: "relative", zIndex: 2, display: "flex", flexWrap: "wrap", gap: 40, alignItems: "stretch", padding: "42px 40px" }}>
            <div className="hero-col" style={{ flex: "1 1 400px", minWidth: "min(100%,400px)", display: "flex", flexDirection: "column", color: "#fff" }}>
              <h1
                className="hero-title hi-title"
                style={{
                  fontFamily: font.display,
                  fontWeight: 700,
                  fontSize: "clamp(2.1rem,4.4vw,3.7rem)",
                  lineHeight: 1.04,
                  textTransform: "uppercase",
                  margin: "16px 0 0",
                  color: "#fff",
                  overflowWrap: "break-word",
                }}
              >
                Системы вентиляции и кондиционирования <span style={{ color: "#ff3b48" }}>под ключ</span>
              </h1>
              <p className="hero-subtext hi-sub" style={{ maxWidth: 560, fontSize: 17, lineHeight: 1.55, color: "#dfe2e7", margin: "20px 0 0" }}>
                От проекта до запуска. Проектируем, монтируем и обслуживаем климатические системы для домов, коттеджей и
                коммерческих объектов в Дмитрове и Московской области.
              </p>
              <div className="hero-cta-row hi-cta" style={{ display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap", marginTop: "auto", paddingTop: 30 }}>
                <button
                  onClick={openRequest}
                  style={{
                    background: colors.red,
                    color: "#fff",
                    border: "none",
                    fontFamily: font.display,
                    fontWeight: 600,
                    fontSize: 16,
                    letterSpacing: ".03em",
                    textTransform: "uppercase",
                    padding: "16px 30px",
                    borderRadius: 10,
                    cursor: "pointer",
                  }}
                >
                  Рассчитать стоимость
                </button>
                <div>
                  <div style={{ fontFamily: font.body, fontSize: 11, letterSpacing: ".1em", textTransform: "uppercase", color: "#bfc4cc" }}>
                    Звоните
                  </div>
                  <a href={contacts.phoneHref} style={{ textDecoration: "none", fontFamily: font.display, fontWeight: 700, fontSize: 22, color: "#fff" }}>
                    {contacts.phone}
                  </a>
                </div>
              </div>
            </div>

            <div className="hi-form" style={{ flex: "1 1 300px", minWidth: "min(100%,300px)", maxWidth: 380 }}>
              <CalcForm variant="glass" button="red" />
            </div>
          </div>
        </div>

        <ServicesStrip
          style={{
            marginTop: 34,
            borderTop: "1px solid #e1e5ea",
            borderBottom: "1px solid #e1e5ea",
            padding: "26px 0",
          }}
        />
      </div>

      <div className="hi-bar" style={{ background: colors.ink, color: "#fff" }}>
        <ObjectTypesBar />
        <div className="hi-line" style={{ height: 2, background: colors.red, maxWidth, margin: "0 auto" }} />
      </div>
    </section>
  );
}
